import { render } from "./why.vue?vue&type=template&id=aff96f58&scoped=true"
import script from "./why.vue?vue&type=script&lang=js"
export * from "./why.vue?vue&type=script&lang=js"

import "./why.vue?vue&type=style&index=0&id=aff96f58&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aff96f58"]])

export default __exports__